module.exports = __webpack_public_path__ + "img/红@3x.88942325.png";